import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiReceiptsIdService(id) {
  return fetch(`receipts/${id}`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
